import {
  FETCH_ANONYMOUS_MESSAGES_LIST,
  FETCH_ANONYMOUS_MESSAGES_LIST_ERROR,
  CLEAR_ANONYMOUS_MESSAGES_LIST,
  DELETE_ANONYMOUS_MESSAGE_SUCCESS,
  DELETE_ANONYMOUS_MESSAGE_ERROR,
  CLEAR_DELETE_ANONYMOUS_MESSAGE_STATUS,
  PATCH_MESSAGE_SETTINGS_SUCCESS,
  PATCH_MESSAGE_SETTINGS_ERROR,
  CLEAR_PATCH_MESSAGE_SETTINGS_STATUS,
  FETCH_ANONYMOUS_MESSAGES_CSV,
  FETCH_ANONYMOUS_MESSAGES_CSV_ERROR,
  CLEAR_FETCH_ANONYMOUS_MESSAGES_CSV,
} from 'redux/anonymous-messages/types';

const initialState = {
  anonymousMessagesList: null,
  anonymousMessagesListError: null,
  deleteAnonymousMessageSuccess: null,
  deleteAnonymousMessageError: null,
  patchAnonymousMessageSuccess: null,
  patchAnonymousMessageError: null,
  anonymousMessagesCsv: null,
  anonymousMessagesCsvError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ANONYMOUS_MESSAGES_LIST:
      return {
        ...state,
        anonymousMessagesList: action.payload.data,
        anonymousMessagesListError: null,
      };
    case FETCH_ANONYMOUS_MESSAGES_LIST_ERROR:
      return {
        ...state,
        anonymousMessagesList: null,
        anonymousMessagesListError: action.payload.data,
      };
    case CLEAR_ANONYMOUS_MESSAGES_LIST:
      return {
        ...state,
        anonymousMessagesList: null,
        anonymousMessagesListError: null,
      };
    case DELETE_ANONYMOUS_MESSAGE_SUCCESS:
      return {
        ...state,
        deleteAnonymousMessageSuccess: action.payload.data,
        deleteAnonymousMessageError: null,
      };
    case DELETE_ANONYMOUS_MESSAGE_ERROR:
      return {
        ...state,
        deleteAnonymousMessageSuccess: null,
        deleteAnonymousMessageError: action.payload.data,
      };
    case CLEAR_DELETE_ANONYMOUS_MESSAGE_STATUS:
      return {
        ...state,
        deleteAnonymousMessageSuccess: null,
        deleteAnonymousMessageError: null,
      };
    case PATCH_MESSAGE_SETTINGS_SUCCESS:
      return {
        ...state,
        patchAnonymousMessageSuccess: action.payload.data,
        patchAnonymousMessageError: null,
      };
    case PATCH_MESSAGE_SETTINGS_ERROR:
      return {
        ...state,
        patchAnonymousMessageSuccess: null,
        patchAnonymousMessageError: action.payload.data,
      };
    case CLEAR_PATCH_MESSAGE_SETTINGS_STATUS:
      return {
        ...state,
        patchAnonymousMessageSuccess: null,
        patchAnonymousMessageError: null,
      };
    case FETCH_ANONYMOUS_MESSAGES_CSV:
      return {
        ...state,
        anonymousMessagesCsv: action.payload.data,
        anonymousMessagesCsvError: null,
      };
    case FETCH_ANONYMOUS_MESSAGES_CSV_ERROR:
      return {
        ...state,
        anonymousMessagesCsv: null,
        anonymousMessagesCsvError: action.payload.data,
      };
    case CLEAR_FETCH_ANONYMOUS_MESSAGES_CSV:
      return {
        ...state,
        anonymousMessagesCsv: null,
        anonymousMessagesCsvError: null,
      };
    default:
      return state;
  }
};
